import styled from "styled-components";
import colours from "styles/colours";

export const StyledWarningContainer = styled.div`
  display: flex;
  border: 1px solid ${colours.darkOrange};
  border-radius: 3px;
  padding: 0.7em;
  text-align: left;
  gap: 0.5em;
  width: fit-content;
  align-items: center;
`;
